//==============================================
// Block: Firm Facts
//==============================================

(function ($) {

    var initBlockFacts = function( $block ) {
        
        let blockFactCell = $block.find('.block-firm-facts__cell');
    
        let blockInit = gsap.timeline({
            scrollTrigger: {
                trigger: $block,
                start: 'top 80%'
                //markers: true
            }
        });
    
        blockInit.from(blockFactCell, {
            duration: 1,
            stagger: 0.2,
            y: '8rem',
            opacity: 0
        })
        
        
    
    };
    
    
    // Initialize each block on page load (front end).
    $(function(){
        $('.block-firm-facts').each(function(){
            initBlockFacts( $(this) );
        });
    });
    
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=block-firm-facts', initBlockFacts );
    }
    
    })(jQuery);